import { __assign } from "tslib";
import { create } from "zustand";
export var useUploadPopover = create(function () { return ({
    uploads: {},
}); });
export var uploadFiles = function (files, parent, body) {
    if (parent === void 0) { parent = undefined; }
    if (body === void 0) { body = undefined; }
    var uploads = __assign({}, useUploadPopover.getState().uploads);
    for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var id_ = crypto.randomUUID();
        uploads[id_] = __assign(__assign({ file: file, state: "waiting" }, (!!parent && {
            parent: parent,
        })), (!!body && {
            body: body,
        }));
    }
    useUploadPopover.setState({ uploads: uploads });
};
export var setUploadState = function (id, newState, message) {
    if (message === void 0) { message = undefined; }
    useUploadPopover.setState(function (state) {
        var _a;
        return ({
            uploads: __assign(__assign({}, state.uploads), (_a = {}, _a[id] = __assign(__assign({}, state.uploads[id]), { state: newState, message: message }), _a)),
        });
    });
};
